"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetupDirectDebitUI = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var screen_reader_route_manager_1 = __importDefault(require("screen-reader-route-manager"));
var legacy_queries_1 = require("../../../../../shared/api/legacy-queries");
var core_1 = require("../../../../../shared/core");
var section_ids_1 = require("../../../section-ids");
var utils_1 = require("../../../utils");
var components_1 = require("./components");
var formatSetupData = function (_a) {
    var amount = _a.amount, dayOfMonth = _a.dayOfMonth, givenName = _a.givenName, familyName = _a.familyName, accountNumber = _a.accountNumber, sortCode = _a.sortCode;
    return ({
        amountInPence: (0, utils_1.formatAsPence)(amount),
        dayOfMonth: dayOfMonth,
        givenName: givenName,
        familyName: familyName,
        accountNumber: (0, utils_1.stripSpaces)(accountNumber),
        sortCode: (0, utils_1.stripSpacesAndDashes)(sortCode),
    });
};
var SetupDirectDebitUI = function (_a) {
    var accountId = _a.accountId, directDebit = _a.directDebit, profile = _a.profile;
    var Pii = (0, core_1.useComponents)().Pii;
    var navigate = (0, ui_tools_1.useNavigate)();
    var _b = (0, core_1.useLinks)(), payments = _b.payments, setupDirectDebitConfirmation = _b.setupDirectDebitConfirmation;
    var _c = __read((0, react_1.useState)(null), 2), error = _c[0], setError = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), review = _d[0], setReview = _d[1];
    var _e = __read((0, react_1.useState)({
        amount: '',
        dayOfMonth: 1,
        givenName: '',
        familyName: '',
        accountNumber: '',
        sortCode: '',
        bankAuthorised: false,
        ddGuaranteeAccepted: false,
    }), 2), values = _e[0], setValues = _e[1];
    var setupDirectDebitMutation = (0, legacy_queries_1.useSetupDirectDebitLegacyMutation)(accountId, function () {
        screen_reader_route_manager_1.default.beforeRouteChange();
        navigate(setupDirectDebitConfirmation());
    }, function (error) {
        setError(error.response && error.response.status === 409
            ? 'alreadyExists'
            : 'other');
    });
    var handleReview = function (updatedValues) {
        setValues(updatedValues);
        setReview(true);
    };
    var handleCancel = function () {
        screen_reader_route_manager_1.default.beforeRouteChange();
        navigate(payments());
    };
    var handleCorrection = function () {
        setError(null);
        setReview(false);
    };
    var handleSubmit = function () {
        if (setupDirectDebitMutation.status === 'in-progress') {
            return;
        }
        setError(null);
        setupDirectDebitMutation.mutate(formatSetupData(values));
    };
    if ((directDebit === null || directDebit === void 0 ? void 0 : directDebit.dayOfMonth) || profile.address == null) {
        handleCancel();
    }
    return (react_1.default.createElement("section", { id: section_ids_1.SETUP_DD_SECTION_ID },
        react_1.default.createElement(Pii, { as: "div" }, review ? (react_1.default.createElement(components_1.SetupDirectDebitReview, { address: profile.address, values: values, handleSubmit: handleSubmit, handleCorrection: handleCorrection, handleCancel: handleCancel, isUpdating: setupDirectDebitMutation.status === 'in-progress', error: error })) : (react_1.default.createElement(components_1.SetupDirectDebitForm, { values: values, handleReview: handleReview })))));
};
exports.SetupDirectDebitUI = SetupDirectDebitUI;
